import CareServiceBudgetRecommendation from './CareServiceBudgetRecommendation';

export default CareServiceBudgetRecommendation;
